import { defineComponent as _defineComponent } from 'vue'
import { ContentLoader } from '@tencent/wphk-components-content-loader';
import Container from '@/components/card-container.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'module-skeleton',
  setup(__props) {

const items = [0, 1, 2, 3, 4, 5];

return { __sfc: true,items, ContentLoader, Container }
}

})